
/**
 * @prop {string} input 传入的value值
 * @prop {fun} changeVal 修改value的方法
 * @prop {string} className 类名
 * @prop {string} placeholder input的placeholder
 */


import React, { Component } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import './simpleNumKeyboard.less'
import common from '../../util/common'
import {Ticon} from 'tplus-components-touch'
export default class extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      layoutName: "default",
      input: this.props.input || ''
    };
  }

  componentDidMount() {
    var _this=this;
    setTimeout(() => {
      _this.setKeyboard();
      _this.inputEl.focus();
      common.setFocus(_this.inputEl)
    }, 0)
  }

  componentWillUnmount(){
    common.setFocus()
  }

  componentWillReceiveProps(nextProps){
    const {input} = nextProps;
    this.setState({input},()=>{
      this.setKeyboard();
    })
  }

  setKeyboard=()=>{
    this.keyboard && this.keyboard.setInput(this.state.input)
  }

  back() {
    let input = this.state.input; 
    this.changeVal(input.substr(0,input.length-1))
  }

  clear(){
    this.changeVal('')
  }

  onChange = input => {
    const change = this.props.changeVal;
    this.setState({
      input: input
    }, () => {
      change && change(input)
    });
    console.log("Input changed", input);
  };

  onKeyPress = button => {
    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  handleShift = () => {
    let layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === "default" ? "shift" : "default"
    });
  };

  onChangeInput = event => {
    let input = event.target.value;
    this.changeVal(input);
  };

  changeVal=(input)=>{
    const change = this.props.changeVal;
    this.setState(
      {
        input: input
      },
      () => {
        change && change(input)
        this.keyboard.setInput(input);
      }
    );
  }

  render() {
    const { className = '', placeholder, renderIcon } = this.props
    return (
      <div className={'tipnumberKeyboardVer ' + className}>
        <div className='input-container'>
          <input
           ref={(el)=>{this.inputEl=el}}
            value={this.state.input}
            placeholder={placeholder}
            onChange={e => this.onChangeInput(e)}
          />
          {renderIcon && renderIcon()}
        </div>

        <Keyboard
          keyboardRef={r => (this.keyboard = r)}
          layout={{
            'default': [
              '7 8 9',
              '4 5 6',
              '1 2 3',
              ' 0 '
            ]
          }}
          layoutName={this.state.layoutName}
          onChange={input => this.onChange(input)}
          onKeyPress={button => this.onKeyPress(button)}
        />
         <span className='back' onClick={()=>{this.back()}}>
            <Ticon type={'tuige'} className='tuige' />
          </span>
          <span className='clear' onClick={()=>{this.clear()}}>
            清空
          </span>
      </div>
    );
  }
}


